export const conversationFragment = `
 communication {
    _id
    email {
      _id
      to
      from
      timeStamp
      content
    }
  }
`
